exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lines2[data-v-68cb9a05]{display:block;display:-webkit-box;margin:0 auto;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.info_text[data-v-68cb9a05]{vertical-align:middle;width:100%}.info_component[data-v-68cb9a05]{background-color:#f6f6f8;width:100%;line-height:20px;margin-top:20px;font-family:Roboto;font-style:normal;font-weight:400;font-size:18px;color:#777}", ""]);

// exports
